module.exports = "#Locations {\n  display: block;\n}\n/*# sourceMappingURL=src/app/locations/locations.component.css.map */"